import React from 'react';
import { Image } from 'react-bootstrap';
import SpeedomterSVG from './Speedometer';
import pointer from '../../../../public/assets/icons/Needle.svg';
import { calculateNeedleRotation } from '../../../core-utils/helpers/helpers';
import { Coordinates } from '../../../core-utils/types/types';
import './styles.scss';

interface NeedleProps {
    value: number;
    org?: Coordinates;
    dept?: Coordinates;
}

const Needle = ({ value, org, dept }: NeedleProps) => {
    const rotation = calculateNeedleRotation(value);
    return (
        <div>
            <div className="speedometer__speedometer-image">
                <SpeedomterSVG org={org} dept={dept} />
            </div>

            <div className="speedometer__speedometer-needle">
                <Image
                    src={pointer}
                    style={{
                        transform: `translateX(30px) rotate(${rotation}deg)`,
                    }}
                />
            </div>
        </div>
    );
};

export default Needle;
